<button
    class="tab-button"
    [class.active]="isActive()"
    role="tab"
    [attr.aria-selected]="isActive()"
    (click)="onClick.next(value())"
>
    <span class="tab-label"><ng-content></ng-content></span>
</button>
